import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,

  Alert,
  IconButton,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { USE_MOCK } from '../config/api';
import CheckinForm from '../components/CheckinForm';

const CheckinPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #004792 0%, #38A845 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Container maxWidth="sm" sx={{ p: { xs: 1, sm: 2 } }}>
        <IconButton
          onClick={() => navigate('/home', { replace: true })}
          sx={{
            mb: 2,
            ml: { xs: -1, sm: 0 },
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
          }}
        >

          <ArrowBack />
        </IconButton>

        <Paper elevation={8} sx={{ p: 4, borderRadius: 3 }}>
          {USE_MOCK && (
            <Alert severity="info" sx={{ mb: 3 }}>

              <Typography variant="body2">
                <strong>Modo Mock Ativo:</strong> O check-in será simulado
                localmente.
              </Typography>
            </Alert>
          )}


          <Box sx={{ textAlign: 'center', mb: 3 }}>

            <Box
              component="img"
              src="/images/logo_nimo_energia_comprida.png"
              alt="Nimo Energia"
              sx={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: 80,
                objectFit: 'contain',
              }}
            />
          </Box>


          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
              Check-in de Motorista
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Preencha os dados abaixo para realizar o check-in
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}


          <CheckinForm onError={setError} onSuccess={setSuccess} />
        </Paper>
      </Container>

      {/* Pop-up fixo */}
      <Box
        sx={{
          position: 'fixed',
          top: 16,

          right: 16,

          left: { xs: 16, sm: 'auto' }, // Adiciona left para centralizar/ajustar em telas pequenas
          zIndex: 9999,
          minWidth: { xs: 'auto', sm: 300 },

          maxWidth: { xs: 'calc(100% - 32px)', sm: 300 }, // Limita a largura em telas pequenas
        }}
      >

        <Alert severity="info" sx={{ fontSize: 14 }}>
          Caso não encontre seu nome, procure pelo nome da empresa terceira pela
          qual está realizando a viagem.
        </Alert>
      </Box>
    </Box>
  );
};

export default CheckinPage;


